/**
 * FYKA — Links que apuntan a la página actual (sep 2026)
 * -----------------------------------------------------
 * Problema observado en iOS Safari:
 * tocar un link cuyo destino es la página en la que ya estás dispara una
 * recarga completa del documento. Safari pinta el comienzo de la página un
 * instante y después restaura la posición de scroll anterior, así que la
 * persona ve un pantallazo del hero y vuelve a quedar donde estaba.
 *
 * Casos concretos en Fyka:
 * - Footer, logo "FYKA", estando en la Home            -> /
 * - Footer, "Mats" estando en /collections/mats
 * - Footer, "Accesorios" estando en /collections/accesorios
 * - Footer, botón lima "Ver colección" estando en /collections/all
 *
 * Solución:
 * si el destino es exactamente la URL actual, no navegamos. Subimos al
 * principio de la página, que es lo que la persona espera al tocar ese link.
 *
 * Lo que NO toca:
 * - anclas dentro de la misma página (#productos): salto nativo intacto
 * - cualquier link a otra URL: navegación normal
 * - links externos, mailto/tel, target=_blank, descargas
 */
(() => {
  'use strict';

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const anchor =
        event.target instanceof Element
          ? event.target.closest('a[href]')
          : null;

      if (!anchor) return;
      if (anchor.hasAttribute('download')) return;
      if (anchor.target && anchor.target !== '_self') return;

      const rawHref = anchor.getAttribute('href') || '';
      if (!rawHref || rawHref.startsWith('#')) return;
      if (/^(mailto:|tel:|sms:|javascript:)/i.test(rawHref)) return;

      let url;
      try {
        url = new URL(anchor.href, window.location.href);
      } catch (_) {
        return;
      }

      if (url.origin !== window.location.origin) return;

      // Ancla dentro de la misma página: dejamos el comportamiento nativo.
      if (url.hash) return;

      // Otra página: navegación normal.
      if (url.pathname !== window.location.pathname) return;
      if (url.search !== window.location.search) return;

      // A partir de acá, el destino es la página actual.
      event.preventDefault();

      // Si el menú móvil estaba abierto, lo cerramos: quedaría tapando el hero
      // al que acabamos de subir.
      document
        .querySelectorAll('[data-fyka-quality-mobile-menu], [data-fyka-about-mobile-menu]')
        .forEach((menu) => {
          menu.hidden = true;
        });

      document
        .querySelectorAll('[data-fyka-quality-menu-button], [data-fyka-about-menu-button]')
        .forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('is-open');
        });

      // Subida instantánea. El scroll suave desde el footer de una página larga
      // tarda demasiado y se siente como que el sitio se colgó.
      const html = document.documentElement;
      const previousBehavior = html.style.scrollBehavior;

      // En escritorio (desde 990px) Horizon no desplaza la ventana sino la caja
      // interna .page-wrapper, así que también la subimos a ella.
      const pageWrapper = document.querySelector('.page-wrapper');
      const previousWrapperBehavior = pageWrapper ? pageWrapper.style.scrollBehavior : '';

      html.style.scrollBehavior = 'auto';
      if (pageWrapper) pageWrapper.style.scrollBehavior = 'auto';

      window.scrollTo(0, 0);
      if (pageWrapper) pageWrapper.scrollTo(0, 0);

      html.style.scrollBehavior = previousBehavior;
      if (pageWrapper) pageWrapper.style.scrollBehavior = previousWrapperBehavior;
    },
    true
  );
})();
